class FloatingCta extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.footerEl = document.querySelector(this.footerSelector)
    if (this.footerEl) {
      this.createObserver(this.footerEl, '0px')
    }
  }

  setFooterIntersecting (isIntersecting) {
    this.setAttribute('aria-hidden', isIntersecting)
  }

  intersectionCallback = entries => {
    entries.forEach(entry => {
      this.setFooterIntersecting(entry.isIntersecting)
    })
  }

  createObserver (el, root) {
    const options = {
      root: null,
      rootMargin: root,
      threshold: 0,
    }

    const observer = new IntersectionObserver(
      this.intersectionCallback,
      options,
    )
    observer.observe(el)
  }

  get footerSelector () {
    return `#shopify-section-footer`
  }
}

if (!customElements.get('floating-cta')) {
  customElements.define('floating-cta', FloatingCta)
}
